export default __webpack_public_path__ + "static/media/IconDesc_WreathNoBow.64.c7b4c81d.png";